export { default } from '@shikijs/langs/jsonc'
